module.exports = __webpack_public_path__ + "img/cg.242f12f0.png";